import { For, type JSX, Show } from 'solid-js';
import { t } from '../../i18n';
import { useCardMove } from '../../lib/card-move';
import { meterView, moveMeterLine, moveMeterOut, moveMeterTitle } from '../../lib/move-meter';
import { MoveIcon } from './MoveIcon';

// "Moves this minute" under the Resources bars (#6772, prototype mvBudgetHTML `:1408-1417`),
// once the machine has used a move this minute: one pip per move in its budget, the ones left
// in the live accent and the used ones on the track, then "X of 4 left". At 0 left, the amber
// line with a pause icon, counting down to the server's `free_at`. Every number is the
// machine's own `moves` with the newest answer laid over it (`MovePage.movesOf`); only a card
// with a move handle (an admin on an own-org machine) shows it.

export function MoveMeter(): JSX.Element {
  const m = useCardMove();
  const view = () => {
    if (m === null || !m.on()) return null;
    const v = meterView(m.page.movesOf(m.box().id));
    // The 0-left line counts down to `free_at`: the page clock ticks until then.
    if (v !== null && v.left === 0) m.page.tickUntil(v.freeAtMs);
    return v;
  };
  return (
    <Show when={view()}>
      {(v) => (
        <Show
          when={m === null ? null : moveMeterOut(v(), m.box().display_name, m.page.clock(), t)}
          fallback={
            <p class="move-meter" title={moveMeterTitle(v(), t)}>
              <span>{t('fleet.move.meter_label')}</span>
              <span class="move-meter__pips" aria-hidden="true">
                <For each={v().pips}>
                  {(left) => (
                    <i class="move-meter__pip" classList={{ 'move-meter__pip--lit': left }} />
                  )}
                </For>
              </span>
              <span class="move-meter__left">{moveMeterLine(v(), t)}</span>
            </p>
          }
        >
          {(out) => (
            <p class="move-meter move-meter--out" role="status">
              <MoveIcon glyph="pause" />
              <span>{out()}</span>
            </p>
          )}
        </Show>
      )}
    </Show>
  );
}
